import React, { useContext } from "react";
import axios from "axios";
// import { directoryContext } from "../context/Context";
import { Link } from "react-router-dom";
import "./pages.css";

const SingleForum = () => {
  // const {
  //   forumState: { forums },
  // } = useContext(directoryContext);
  const [forumData, setForumData] = React.useState({});
  const id = window.location.pathname.split("/")[2];
  let fetchRun = false;

  const fetchForum = async () => {
    try {
      fetchRun = true;
      const res = await axios.get(
        "https://www.api.webdirectories.info/api/forum/forum/" + id
      );
      res.status === 200 && setForumData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (id !== undefined && !fetchRun) {
      fetchForum();
    }
  }, [id]);

  if (Object.keys(forumData).length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="container-fluid d-flex flex-column align-items-center justify-content-center"
      style={{
        backgroundColor: "#f5f5f5",
        borderRadius: "10px",
        padding: "20px",
        width: "100%",
      }}
    >
      <h4
        className="text-center"
        style={{
          fontWeight: "300",
          fontSize: "30px",

          marginBottom: "20px",
        }}
      >
        <strong>{forumData.title}</strong>
      </h4>

      <div
        className=" inner-container"
        style={{
          width: "70%",
          height: "100%",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          boxShadow: "0px 0px 10px #ccc",
          padding: "100px",
          margin: "0 auto",
        }}
        dangerouslySetInnerHTML={{ __html: forumData.data }}
      />

      <div className="d-flex justify-content-center my-5">
        <Link to="/forum" className="btn btn-primary">
          <i class="bi bi-arrow-90deg-left"></i> Back to Forums
        </Link>
      </div>
    </div>
  );
};

export default SingleForum;
